import React from "react";
import { classNames } from "../../helpers";

export default function TwFormHelperText(props) {
  const { children, className = "", error = false } = props

  let helperTextClass = "text-black/[0.6]"
  if (error) {
    helperTextClass = "text-red-600"
  }
  return (
    <div className={classNames("mt-2 text-sm ", helperTextClass, className)}>
      {children}
    </div>
  );
}
